import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  generatePaymentLink,
  generatePaymentLinkWithCustomAmount,
} from "../../api/caseApi";
import Spinner from "../../common/components/Spinner";
import { StyledH5 } from "../../common/components/Title/styles";
import { faFaceFrownOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const GenerateLink = () => {
  const [searchParams] = useSearchParams();
  const [invalidRequest, setInvalidRequest] = useState(false);

  useEffect(() => {
    const param = searchParams.get("request");
    console.log(param);
    if (param) {
      const request = JSON.parse(window.atob(param));
      console.log(request);
      fetchPaymentLink(request);
    }
  }, []);

  const fetchPaymentLink = async (request) => {
    try {
      if (request.hasCustomAmount) {
        const response = await generatePaymentLinkWithCustomAmount(
          request.modeOfPayment,
          request.caseProgressId,
          request.amount
        );
        if (response.data && response.data.link) {
          window.location.replace(response.data.link);
        } else {
          setInvalidRequest(true);
        }
      } else {
        const response = await generatePaymentLink(
          request.caseProgressId,
          request.modeOfPayment,
          request.isSubscription
        );
        if (response.data && response.data.link) {
          window.location.replace(response.data.link);
        } else {
          setInvalidRequest(true);
        }
      }
    } catch {
      setInvalidRequest(true);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
      }}
    >
      {!invalidRequest ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Spinner color={"black"} />
          <StyledH5
            theme="green"
            style={{ padding: "0px", paddingTop: "20px" }}
          >
            Generating payment link
          </StyledH5>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon
            style={{ fontSize: "50px" }}
            icon={faFaceFrownOpen}
          />
          <StyledH5
            theme="green"
            style={{ padding: "0px", paddingTop: "20px" }}
          >
            An error occured. Please try again.
          </StyledH5>
        </div>
      )}
    </div>
  );
};

export default GenerateLink;
